module.exports = __webpack_public_path__ + "static/media/05.e8f24f80.jpg";